import Sortable from 'scripts/lib/external/Sortable.min';
import 'scripts/lib/external/jquery.idle';

var preloadURLs = [],
    preloadedURLs = [],
    preloading = false;

(function($) {

    var base = false,
        threshold = 25, // max parallel requests
        requests = 0,
        fonts = [
            '5664085/f9c5199e-a996-4c08-9042-1eb845bb7495.woff2',
            '5664089/5e4f385b-17ff-4d27-a63a-9ee28546c9a8.woff2',
            '5664093/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2',
            '5664098/4bd56f95-e7ab-4a32-91fd-b8704cbd38bc.woff2',
            '5664103/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2',
            '5664150/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2',
            '5663732/9516ef74-4fe9-45fe-a09f-493cb9518f71.woff2',
            '5663739/1a559dd9-e51e-45d5-86eb-f343223bacef.woff2',
            '5663746/02980b3d-1e37-4378-a5c6-4cf0d6ce0ba5.woff2'
        ];

    function preloadURL(url) {
        url = url.trim();
        if(!base) {
            base = document.location.href.match(/https?:\/\/[^\/]+/)[0];
        }
        if(url.match(/^\/[^\/]/)) {
            url = base + url;
        } else if(url.match(/^\/\//)) {
            url = document.location.href.match(/https?:/)[0] + url;
        }
        if(url.match(/\/logout\//))
            return;
        if(url.substr(0, base.length) != base || !url.substr(base.length).match(/\/(content|digital-signage)\//))
            return;
        if(preloadedURLs.indexOf(url) > -1 || preloadURLs.indexOf(url) > -1)
            return;
        preloadURLs.push(url);
        if(!preloading || requests < threshold)
            window.requestAnimationFrame(preloadCache);
    }

    function preloadCache() {
        if(!preloading) {
            preloading = true;
            $('[data-preload]').addClass('loading').width();
        }
        if(!preloadURLs.length && !requests) {
            preloading = false;
            $('[data-preload]').removeClass('loading');
            return;
        }
        if(requests > threshold) {
            window.setTimeout(100, preloadCache);
            return;
        }
        var url = preloadURLs.shift();
        if(!url)
            return;
        if(url in preloadedURLs) {
            preloadCache();
            return;
        }
        requests++;
        preloadedURLs.push(url);
        fetch(url).then(function(response) {
            requests--;
            if(url.match(/\/digital-signage\/[a-z0-9]{32}\//) && response.ok) {
                response.text().then(function(text) {
                    if(!text)
                        return;
                    text = text.replaceAll('\n', ' ')
                               .replaceAll(/<link.*?rel=['"](canonical|icon|manifest|mask-icon|shortcut icon|alternate|dns-prefetch|https:\/\/api\.w\.org\/)['"].*?>/g, '');
                    var i, j, src, cond, match, type,
                        matches = text.match(/(href|src|srcset)=['"](.*?)['"]/g),
                        width = $(window).width();
                    for(i in matches) {
                        match = matches[i].replaceAll(/["']/g, '').split('=');
                        type = match.shift();
                        match = match.join('=');
                        if(type == 'srcset') {
                            match = match.split(',');
                            for(j in match) {
                                src = match[j].split(' ');
                                cond = src.pop();
                                src = src.join(' ');
                                if(cond.replace(/[^0-9]/, '') > width)
                                    continue;
                                preloadURL(src);
                            }
                            continue;
                        }
                        preloadURL(match);
                    }
                });
            }
            window.requestAnimationFrame(preloadCache);
        });
        if(requests < threshold)
            window.requestAnimationFrame(preloadCache);
    }

    var timer = false,
        interval = false;
    function periodicRefresh(e) {
        if(!navigator.onLine || preloading)
            return;
        window.clearInterval(interval);
        preloadedURLs = [];
        preloadURL(document.location.href);
        if(!timer) {
            timer = window.setInterval(function() {
                if(preloading)
                    return;
                document.location.reload();
            }, 1000);
        }
    }
    interval = window.setInterval(periodicRefresh, 1000*60*30);
    $(window).on('online', periodicRefresh);

    function toggleSettings(e) {
        var settings = $('.digital-signage__header-settings');
        if(navigator.onLine) {
            settings.show();
        } else {
            settings.hide();
        }
    }
    $(window).on('online offline', toggleSettings);
    if(!navigator.onLine)
        toggleSettings();

    function load(url, direction) {
        if(!direction)
            direction = 'left';
        var wrapper = $('.digital-signage__wrapper').addClass('unload-' + direction),
            body = $('body').addClass('loading');
        $.get(url, null)
            .done(function(data) {
                wrapper.remove();
                data = data.match(/<body[^>]*>([\s\S\n]*)<\/body>/)[1];
                wrapper = $(data).addClass('noanim unload-' + (direction == 'right' ? 'left' : 'right')).prependTo(body).trigger('rtl.utils.initialized');
                wrapper.width();
                wrapper.removeClass('noanim').width();
                init();
                wrapper.removeClass('unload-' + (direction == 'right' ? 'left' : 'right')).width();
                window.history.pushState({}, $('title').text(), url);
            })
            .fail(function() {
                wrapper.removeClass('unload-' + direction);
            })
            .always(function() {
                body.removeClass('loading');
                toggleSettings();
            });
    }

    $(document).idle({
        onIdle: function() {
            var current = document.location.href,
                target = $('body').data('sw-scope'),
                qsa = current.match(/\?.*$/);

            if (qsa)
                target += qsa;

            if (current != target && !current.endsWith('/settings/')) {
                load(target, 'right');
            }
        },
        idle: 5000 * 60 // 5 minutes
    });

    $('body').on('click', 'a', function(e) {
        var url = $(this).attr('href');
        if(!url || url.match(/^#/) || url.match(/^javascript:/) || url.match(/\/(logout|settings)\/$/))
            return;
        e.preventDefault();
        e.stopImmediatePropagation();
        load(url, url.length < document.location.href.length ? 'right' : 'left');
    }).on('click', 'input', function(e) {
        $(this).focus();
    });

    function init_swipe() {
        if(typeof $.fn.swipe == 'undefined') {
            window.setTimeout(init_swipe, 100);
            return;
        }

        $('body').swipe({
            swipe: function(e, direction, distance, duration, fingerCount, fingerData) {
                if(direction != 'left' && direction != 'right' || distance < 300 || fingerCount > 1)
                    return;
                var url;
                if($('#icons-close:not(:checked)').length) {
                    var next, selected = $('input[name="icons"]:checked');
                    if(direction == 'right') {
                        if(selected.prev('.overlay__header').length)
                            next = $('#icons-close');
                        else
                            next = selected.prev().prev();
                    } else {
                        if(selected.next(':last-child').length)
                            next = selected.parent().find('input[name="icons"]:first');
                        else
                            next = selected.next().next();
                    }
                    if(next.length) {
                        next.prop('checked', true);
                        return;
                    }
                }
                if(direction == 'right') {
                    var overlays = $('#attributes-overlay-closed:not(:checked), #energylabel-close:not(:checked), #icons-close:not(:checked)');
                    if(overlays.length) {
                        overlays.prop('checked', true);
                        return;
                    } else {
                        url = $('.digital-signage__wrapper').data('prev');
                    }
                } else {
                    url = $('.digital-signage__wrapper').data('next');
                }
                if(url) {
                    load(url, direction);
                }
            },
            allowPageScroll: 'vertical'
        });
    }
    $(window).on('load', init_swipe);

    function init() {
        $('[data-toggle="popover"]').popover();
        $('.digital-signage__settings input[name="query"]').each(function() {
            var input = $(this).attr('autocomplete', 'off'),
                url = input.data('url'),
                results = $('<div class="digital-signage__settings-results" />').insertAfter(input),
                form = input.closest('form'),
                selection = form.find('.digital-signage__settings-selection > ul'),
                submit = form.find('button[type="submit"]'),
                sortable = Sortable.create(selection[0], {
                    filter: '[data-remove]',
                    handle: '.handle',
                    animation: 150,
                }),
                cache = {},
                current_xhr = false,
                timer = false,
                selected = false,
                prev = '';

            form.find('button.btn.icon-close').on('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $(this).blur();
                input.val('').trigger('keyup').focus();
            });

            form.on('submit', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                submit.addClass('loading');
                $.post(form.attr('action') + '?ajax=1', form.serializeArray())
                    .done(function(data) {
                        for(var i in data)
                            preloadURLs.push(data[i].replace(/ /g, '+'));
                        preloadCache();
                        for(i in fonts)
                            preloadURL('/content/themes/fors/dist/fonts/' + fonts[i]);
                    })
                    .always(function() {
                        submit.removeClass('loading');
                    });
            });

            results.on('click', 'a', function(e) {
                e.preventDefault();
                var selected = $(e.target).closest('a'),
                    found = selection.find('[data-id="' + selected.data('id') + '"]');
                if(found.length) {
                    selection.prepend(found.closest('li'));
                } else {
                    selection.prepend(selected.data('rendered'));
                }
                input.focus();
            });

            selection.on('click', 'button[data-remove]', function(e) {
                e.preventDefault();
                $(e.target).closest('li').remove();
            });

            function render(items) {
                results.html('');
                var result, item, i;
                for(i=0; i<items.length; i++) {
                    item = items[i];
                    result = $('<a href="javascript://">' + item[1] + '</a>');
                    result.data({
                        id: item[0],
                        rendered: item[2]
                    }).appendTo(results);
                }
            }

            input.on('keyup focus', function(e) {
                var query = input.val();
                if(!query) {
                    results.html('');
                    return;
                }
                if(query == prev)
                    return;
                prev = query;
                if(timer)
                    window.clearTimeout(timer);
                if(current_xhr)
                    current_xhr.abort();
                if(query in cache) {
                    render(cache[query]);
                    return;
                }
                var data = [{name: 'query', value: query}];
                timer = window.setTimeout(function() {
                    results.addClass('loading');
                    current_xhr = $.get(url, data)
                        .done(function(content) {
                            render(cache[query] = content);
                        })
                        .always(function() {
                            results.removeClass('loading');
                        });
                }, 250);
            });
        });
    }

    $(window).on('load', init);

    if ('serviceWorker' in navigator && $('body[data-sw]')) {
        window.addEventListener('load', function() {
            navigator.serviceWorker.register($('body').data('sw'), {
                scope: $('body').data('sw-scope')
            });
        });
    }

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/digital-signage.js